/**
 * Product page: arrow buttons for the "More from <collection>" scroll row (hom-product-b.liquid).
 * The row itself scrolls natively (touch / trackpad); arrows only help desktop mouse users.
 */
class HomRelatedRow {
  /** @param {HTMLElement} sec */
  constructor(sec) {
    const row = sec.querySelector('[data-rel-row]');
    if (!(row instanceof HTMLElement)) return;
    const arrows = sec.querySelectorAll('[data-rel-scroll]');
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const sync = () => {
      const max = row.scrollWidth - row.clientWidth - 2;
      for (const a of arrows) {
        if (!(a instanceof HTMLButtonElement)) continue;
        const dir = Number(a.dataset.relScroll);
        a.disabled = dir < 0 ? row.scrollLeft <= 2 : row.scrollLeft >= max;
      }
    };
    for (const a of arrows) {
      a.addEventListener('click', () => {
        const dir = Number(/** @type {HTMLElement} */ (a).dataset.relScroll);
        row.scrollBy({ left: dir * row.clientWidth * 0.85, behavior: reduce ? 'auto' : 'smooth' });
      });
    }
    row.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync, { passive: true });
    sync();
  }
}

for (const sec of document.querySelectorAll('[id$="-rel"]')) new HomRelatedRow(sec);
